module.exports = __webpack_public_path__ + "static/media/background-800.71c66b9e.jpg";